/**
 * @fileoverview POST handler for the "/engagement/link_templates(/:id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLinkTemplatesIdCacheKeys } from "./constants";
import type { PostEngagementLinkTemplatesParams, PostEngagementLinkTemplatesIdResult } from "./types";

export const postEngagementLinkTemplatesId = reactQueryMutationAdapter(
  engagementLinkTemplatesIdCacheKeys,
  (props: PostEngagementLinkTemplatesParams): Promise<PostEngagementLinkTemplatesIdResult> => {
    return fetch(`/engagement/link_templates${props.id ? `/${props.id}` : ""}`, "POST", props);
  }
);
